import { formatters, type ServerColDef, type ValueFormatterParams } from '@cmg/data-grid';
import defaultTo from 'lodash/defaultTo';

import type { UnderwriterEmployeeFragment } from '../components/SalesCoverageGrid/graphql/__generated__';

export function valueFormatter({ data }: ValueFormatterParams<UnderwriterEmployeeFragment>) {
  const emails = [defaultTo(data?.email1, '-')];

  if (data?.email2) {
    emails.push(data.email2);
  }

  return formatters.truncatedArrayValueFormatter(emails);
}

const emailColDef: ServerColDef<UnderwriterEmployeeFragment> = {
  field: 'email1',
  headerName: 'Email',
  minWidth: 220,
  tooltipField: 'email2',
  valueFormatter,
  filterParams: {
    filterOptions: ['equals', 'notEqual'],
  },
};

export default emailColDef;
